import { fetcher } from '../utils'
import { IntegratedLoginVO } from '@repo/types'

export default async (input: IntegratedLoginVO): Promise<string> => fetcher('api/public/setup', 'POST', input)
